import React, { PropTypes } from 'react';

const Address = ({ className, address, includeCountry, googleLink }) => {
  const components = [];

  if (address.line1) components.push(address.line1);
  if (address.line2) components.push(address.line2);
  if (address.city) components.push(address.city);
  if (address.state) {
    if (address.country.code === 'US') {
      components.push(address.state.code);
    } else if (address.state.name || address.state.code) {
      components.push(address.state.name || address.state.code);
    }
  }
  if (address.postal_code) components.push(address.postal_code);
  components.push(address.country.name);

  let addrString = components.join(', ');

  const addrUri = ['https://www.google.com/maps/place'];
  addrUri.push(addrString.split(' ').join('+'));
  if (address.coords) {
    addrUri.push(`@${address.coords.coordinates[1]},${address.coords.coordinates[0]},17z`);
  }

  if (!includeCountry) {
    addrString = components.slice(0, components.length - 1).join(', ');
  }

  return (
    <div className={['address', className].join(' ')}>
      { googleLink ?
        <a
          target='_blank'
          rel='noopener noreferrer'
          href={addrUri.join('/')}
        >
          { addrString }
        </a>
      : addrString }
    </div>
  );
};

Address.propTypes = {
  address: PropTypes.shape({
    line1: PropTypes.string,
    line2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string,
    }),
    postal_code: PropTypes.string,
    country: PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string,
    }),
    coords: PropTypes.shape({
      coordinates: PropTypes.arrayOf(PropTypes.number),
    }),
  }).isRequired,
  className: PropTypes.string,
  googleLink: PropTypes.bool,
  includeCountry: PropTypes.bool,
};

Address.defaultProps = {
  className: null,
  googleLink: false,
  includeCountry: true,
};

export default Address;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/Address/index.jsx